import type { IAggregate } from '../interfaces';

export class Aggregate implements IAggregate {
    public static parseObject(obj: IAggregate): Aggregate {
        try {
            return new Aggregate(obj);
        } catch (error) {
            throw new Error(
                `Could not parse Aggregate object : ${JSON.stringify(obj)}`,
            );
        }
    }

    public static empty() {
        return Aggregate.parseObject({
            kontrakterUnderUtloep: 0,
            sumUnderUtloep: 0,
            sumArealUnderUtloep: 0,
            sumUtleid: 0,
            sumUtleidMedUtloep: 0,
            sumArealUtleid: 0,
            sumLedig: 0,
            sumLedigMedUtloep: 0,
            sumArealLedig: 0,
            oekonomiskUtleiegrad: 0,
            oekonomiskUtleiegradMedUtloep: 0,
            arealmessigUtleiegrad: 0,
            linjerUnderUtloep: 0,
            grupperteLinjerUnderUtloep: 0,
            totalPotensiellLeie: 0,
            totaltAreal: 0,
            fremtidigArealmessigUtleiegrad: 0,
            fremtidigOkonomiskUtleiegrad: 0,
        });
    }

    kontrakterUnderUtloep: IAggregate['kontrakterUnderUtloep'];
    sumUnderUtloep: IAggregate['sumArealUnderUtloep'];
    sumArealUnderUtloep: IAggregate['sumArealUnderUtloep'];
    sumUtleid: IAggregate['sumUtleid'];
    sumUtleidMedUtloep: IAggregate['sumUtleidMedUtloep'];
    sumArealUtleid: IAggregate['sumArealUtleid'];
    sumLedig: IAggregate['sumLedig'];
    sumLedigMedUtloep: IAggregate['sumLedig'];
    sumArealLedig: IAggregate['sumArealLedig'];
    oekonomiskUtleiegrad: IAggregate['oekonomiskUtleiegrad'];
    oekonomiskUtleiegradMedUtloep: IAggregate['oekonomiskUtleiegradMedUtloep'];
    arealmessigUtleiegrad: IAggregate['arealmessigUtleiegrad'];
    linjerUnderUtloep: IAggregate['linjerUnderUtloep'];
    grupperteLinjerUnderUtloep: IAggregate['grupperteLinjerUnderUtloep'];
    totalPotensiellLeie: IAggregate['totalPotensiellLeie'];
    totaltAreal: IAggregate['totaltAreal'];
    fremtidigArealmessigUtleiegrad: IAggregate['fremtidigArealmessigUtleiegrad'];
    fremtidigOkonomiskUtleiegrad: IAggregate['fremtidigOkonomiskUtleiegrad'];

    constructor(props: IAggregate) {
        Object.assign(this, props);

        this.sumLedigMedUtloep = this.sumLedig + this.sumUnderUtloep;
        this.sumUtleidMedUtloep = this.sumUtleid - this.sumUnderUtloep;

        this.oekonomiskUtleiegradMedUtloep =
            (this.sumUtleid / (this.sumLedigMedUtloep + this.sumUtleid)) * 100;
    }
}
